import { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { PageHeader, PageTabs } from '@/components/common';
import GlobalPromptQuestions from '@/components/globalPrompts/GlobalPromptQuestions';
import GlobalPromptInsights, { DEFAULT_DATE_RANGE, readActiveFilter } from '@/components/globalPrompts/insights/GlobalPromptInsights';
import { InsightsDateRange } from '@/components/globalPrompts/insights/insightsTypes';

const QUESTIONS_TAB = 0;

const GlobalPromptsPage: React.FC = () => {
    const [activeTab, setActiveTab] = useState<number>(QUESTIONS_TAB);
    // The insights filter is held here rather than in the tab, because switching tabs unmounts the
    // tab and would otherwise reset the filter. It resets when the user leaves the page, as before.
    //
    // If a run was in progress when the page was left or refreshed, start on that filter.
    // Otherwise start on the default.
    const [dateRange, setDateRange] = useState<InsightsDateRange>(() => readActiveFilter()?.dateRange ?? DEFAULT_DATE_RANGE);
    const [projectIds, setProjectIds] = useState<number[]>(() => readActiveFilter()?.projectIds ?? []);

    return (
        <Box>
            <PageHeader>
                <Typography variant="h2" component="h1">
                    Global Prompts
                </Typography>
                <Typography variant="body2" component="p" color="gray.60">
                    AI analyzes these questions across all project transcripts and surfaces cross-project insights
                </Typography>
            </PageHeader>

            <PageTabs
                ariaLabel="Global prompts tabs"
                activeTab={activeTab}
                onTabChange={setActiveTab}
                tabs={[
                    { label: 'Questions', id: 'questions' },
                    { label: 'Insights', id: 'insights' },
                ]}
            >
                <GlobalPromptQuestions />
                <GlobalPromptInsights
                    onConfigureQuestions={() => setActiveTab(QUESTIONS_TAB)}
                    dateRange={dateRange}
                    projectIds={projectIds}
                    onDateRangeChange={setDateRange}
                    onProjectIdsChange={setProjectIds}
                />
            </PageTabs>
        </Box>
    );
};

export default GlobalPromptsPage;
